import React from "react";
import {Controller} from "react-hook-form";
import WorkForceCaseImageCreateUploadComponent
    from "../../../components/WorkForce/WorkforceCaseImageCreateUploadComponent";

// this view adds functionality to the antd upload class
const CaseImageAttachment = ({control}) => {
    return (
        <div>
            <p className="font-bold text-sm">Image Attachment</p>
            <Controller
                control={control}
                name={"attachmentUrls"}
                render={({field}) => {
                    return <WorkForceCaseImageCreateUploadComponent
                        value={field.value}
                        onChange={field.onChange}
                    />
                }}/>

        </div>
    );
};

export default CaseImageAttachment;


